export default "__VITE_ASSET__5692bd78__"